// extracted by mini-css-extract-plugin
export default {"container":"adminsettings_container__oC9DR","noti_container":"adminsettings_noti_container__XkOP3"};